import React, { useState, useEffect, useRef } from "react";
import "./SearchLocationInput.style.scss";

import { Tooltip } from "antd";
import Spinner from "components/Spinner/Spinner";
import { openNotificationWithIcon } from "utils/Notification";


function SearchLocationInput({
  guests,
  name,
  form,
  className = "search-location-input",
  loading,
  onChange,
  streetAddress,
  clearData,
  ...props
}) {
  const [value, setValue] = useState("");
  const selectingRef = useRef(false); // <--- flag to indicate selection in progress


  const autoCompleteRef = useRef(null);
  const autoCompleteInstance = useRef(null); // ✅ local instance

  useEffect(() => {
    if (streetAddress !== '') {
      setValue(streetAddress || "");
    }
  }, [streetAddress])

  useEffect(() => {
    handleScriptLoad(autoCompleteRef);
    return () => {
      window.google.maps.event.clearInstanceListeners(autoCompleteInstance);
      autoCompleteInstance.current = null;
    };
  }, []);

  function handleScriptLoad(autoCompleteRef) {
    autoCompleteInstance.current = new window.google.maps.places.Autocomplete(
      autoCompleteRef.current,
      {
        componentRestrictions: { country: "US" },
      }
    );
    autoCompleteInstance.current.setFields(["address_components", "formatted_address"]);
    autoCompleteInstance.current.addListener("place_changed", handlePlaceSelect);
  }

  // Manually Replicate all other functionality
  async function handlePlaceSelect() {
    // mark selection in progress so blur handler can ignore
    selectingRef.current = true;
    // keep true for a short window; blur usually fires before place_changed
    setTimeout(() => {
      selectingRef.current = false;
    }, 300);


    if (autoCompleteInstance.current === null) {
      openNotificationWithIcon('error', 'Error!', "Google Maps API is not loaded");
      return;
    }

    const place = autoCompleteInstance?.current?.getPlace();
    const address = place?.formatted_address;
    onChange({
      target: {
        value: address || "",
      }
    })
    setValue(address || "")
  }

  return (
    <div className={`locationDropdown ${className}`}>
      <Tooltip placement="topLeft" title={value}>
        <input
          ref={autoCompleteRef}
          placeholder="Enter Address"
          style={{ maxWidth: 500 }}
          className={"locationInput"}
          {...props}
          value={value}
          onChange={(e) => {
            setValue(e.target.value)
            clearData()
          }}
          onBlur={() => {
            // defer blur handling so place_changed can set selectingRef
            setTimeout(() => {
              if (selectingRef.current) {
                // ignore blur caused by selecting an autocomplete option
                return;
              }
              if (streetAddress) {
                onChange({
                  target: {
                    value: streetAddress || "",
                  },
                });
                setValue(streetAddress || "");
              }
            }, 150);
          }}
        />
      </Tooltip>
    </div>
  );
}

export default SearchLocationInput;
